import React from "react"
import PropTypes from "prop-types"

import styles from "./TextArea.module.css"

const TextArea = props => (
  <textarea
    className={styles.component}
    name={props.name}
    placeholder={props.placeholder}
    required={props.required}
    id={props.id}
  >
    {props.children}
  </textarea>
)

TextArea.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
}

export default TextArea
